import 'svelte/internal/disclose-version';

Caption[$.FILENAME] = 'client/lib/Caption.svelte';

import * as $ from 'svelte/internal/client';

var root = $.add_locations($.from_html(`<p class="font-comic text-5xl leading-none tracking-wide text-orange [text-shadow:2px_2px_0_#17150f]"> </p>`), Caption[$.FILENAME], [[7, 13]]);

var root_1 = $.add_locations(
	$.from_html(
		`

<div>
  <!>
  <div class="mt-3 font-comic text-2xl leading-tight tracking-wide"><!></div>
</div>`,
		1
	),
	Caption[$.FILENAME],
	[[6, 0, [[8, 2]]]]
);

function Caption($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, true, Caption);

	let cls = $.prop($$props, 'class', 3, "");
	var $$exports = { ...$.legacy_api() };

	$.next();

	var fragment = root_1();
	var div = $.sibling($.first_child(fragment));
	var node = $.sibling($.child(div));

	{
		var consequent = ($$anchor) => {
			var p = root();
			var text = $.only_child(p, true);

			$.template_effect(() => $.set_text(text, $$props.title));
			$.append($$anchor, p);
		};

		$.add_svelte_meta(
			() => $.if(node, ($$render) => {
				if ($$props.title) $$render(consequent);
			}),
			'if',
			Caption,
			7,
			2
		);
	}

	var div_1 = $.sibling(node, 2);
	var node_1 = $.child(div_1);

	$.add_svelte_meta(() => $.snippet(node_1, () => $$props.children), 'render', Caption, 8, 68);
	$.reset(div_1);
	$.next();
	$.reset(div);
	$.template_effect(() => $.set_class(div, 1, `border-[3px] border-ink bg-paper px-8 py-6 shadow-[5px_5px_0_#17150f] ${cls() ?? ''}`));
	$.append($$anchor, fragment);

	return $.pop($$exports);
}

if (import.meta.hot) {
	Caption = $.hmr(Caption);

	import.meta.hot.accept((module) => {
		Caption[$.HMR].update(module.default);
	});
}

export default Caption;